import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, provide, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { FadeTransition } from '@/modules/common/components/FadeTransition';

import {
  getWithdrawDetails,
  getWithdrawReview,
  makeWithdraw,
  IWithdrawDetails,
  IWithdrawReview,
  IWithdrawConclusion
} from '@/modules/transaction/services/product-withdraw';
import { isBFFError } from '@/modules/common/helpers/bff';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import { ProductWithdrawComponents, EProductWithdrawSteps } from './helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductWithdraw',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const currentStep = ref(EProductWithdrawSteps.WITHDRAW);
const withdrawDetails = ref<IWithdrawDetails>();
const withdrawReview = ref<IWithdrawReview>();
const withdrawConclusion = ref<IWithdrawConclusion>();

const isLoading = ref(true);
const isFetchingReview = ref(false);
const isFetchingWithdraw = ref(false);
const hasError = ref(false);
const amount = ref(0);

const step = computed(() => {
  return {
    component: ProductWithdrawComponents[currentStep.value]
  };
});

const showNavbar = computed(() => {
  return currentStep.value !== EProductWithdrawSteps.CONCLUSION;
});

const productId = computed(() => {
  const { id } = route.params;

  return id;
});

function onBack() {
  if (currentStep.value === EProductWithdrawSteps.WITHDRAW) return onClose();

  currentStep.value = currentStep.value - 1;
}

function onClose() {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    router.push({ name: 'productsCatalog' });
  }
}

async function fetchWithdrawDetails() {
  try {
    isLoading.value = true;
    hasError.value = false;

    withdrawDetails.value = await getWithdrawDetails(productId.value);
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchWithdrawReview(amountValue: number) {
  amount.value = amountValue;

  try {
    isFetchingReview.value = true;

    withdrawReview.value = await getWithdrawReview(
      productId.value,
      amount.value
    );

    currentStep.value = EProductWithdrawSteps.REVIEW;
  } catch (e) {
    let errorMessage =
      'Não foi possível realizar a operação, por favor tente novamente.';

    if (isBFFError(e)) {
      errorMessage = e.error.message.formatted;
    }

    notify({
      group: 'wrn-notifications',
      text: errorMessage,
      type: NotificationTypes.error
    });
  } finally {
    isFetchingReview.value = false;
  }
}

async function fetchWithdraw() {
  try {
    isFetchingWithdraw.value = true;

    withdrawConclusion.value = await makeWithdraw(
      productId.value,
      amount.value
    );

    currentStep.value = EProductWithdrawSteps.CONCLUSION;
  } catch (e) {
    let errorMessage =
      'Não foi possível realizar a operação, por favor tente novamente.';

    if (isBFFError(e)) {
      errorMessage = e.error.message.formatted;
    }

    notify({
      group: 'wrn-notifications',
      text: errorMessage,
      type: NotificationTypes.error
    });
  } finally {
    isFetchingWithdraw.value = false;
  }
}

onMounted(fetchWithdrawDetails);

provide('withdrawDetails', withdrawDetails);
provide('withdrawReview', withdrawReview);
provide('withdrawConclusion', withdrawConclusion);
provide('isFetchingReview', isFetchingReview);
provide('isFetchingWithdraw', isFetchingWithdraw);
provide('productId', productId);

provide('fetchWithdrawReview', fetchWithdrawReview);
provide('fetchWithdraw', fetchWithdraw);

return { __sfc: true,route, router, currentStep, withdrawDetails, withdrawReview, withdrawConclusion, isLoading, isFetchingReview, isFetchingWithdraw, hasError, amount, step, showNavbar, productId, onBack, onClose, fetchWithdrawDetails, fetchWithdrawReview, fetchWithdraw, NavBar, LoaderIndicator, HelperViewStatus, BackButton, FadeTransition }
}

})